var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 22.375C12.9281 22.375 14.3423 22.0937 15.6617 21.5472C16.9811 21.0007 18.1799 20.1996 19.1898 19.1898C20.1996 18.1799 21.0007 16.9811 21.5472 15.6617C22.0937 14.3423 22.375 12.9281 22.375 11.5C22.375 10.0719 22.0937 8.65773 21.5472 7.33832C21.0007 6.0189 20.1996 4.82005 19.1898 3.81021C18.1799 2.80038 16.9811 1.99933 15.6617 1.45281C14.3423 0.90629 12.9281 0.625 11.5 0.625C8.61577 0.625 5.84967 1.77076 3.81021 3.81021C1.77076 5.84967 0.625 8.61577 0.625 11.5C0.625 14.3842 1.77076 17.1503 3.81021 19.1898C5.84967 21.2292 8.61577 22.375 11.5 22.375ZM11.2197 15.8983L17.2613 8.64833L15.4053 7.10167L10.2095 13.3355L7.52096 10.6457L5.81238 12.3543L9.43738 15.9793L10.3726 16.9145L11.2197 15.8983Z",
    fill: "#3BB370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.ebbd37a7977f5e13ee8eec569b8e6e42.svg";
export { ForwardRef as ReactComponent };